import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "mainbox clearfix" }
const _hoisted_6 = { class: "top" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "items clearfix" }
const _hoisted_11 = { class: "img" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = {
  key: 0,
  class: "line"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "cont" }
const _hoisted_16 = { class: "mainbox" }
const _hoisted_17 = { class: "tabs clearfix" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "iconfont icon-henggang"
}
const _hoisted_20 = { class: "box" }
const _hoisted_21 = {
  key: 0,
  class: "list clearfix"
}
const _hoisted_22 = ["src"]

import {reactive, onMounted , watch ,ref} from "vue";
import Nav from '@/components/nav/Index.vue';
import { getEnum ,getCustomer  } from "@/api/index";
 import { useRouter , useRoute } from "vue-router";
 
import { getActive } from "@/api/backstage";
import { fa } from "element-plus/lib/locale";
 

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;
const acrRef: any = ref(null);
const mb =ref(false);
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);
 
 const router = useRouter();
 
const datas: any = reactive({
  show:true,
  banner:'',
  filurl:localStorage.getItem('fileUrel'),
  tops:[],
  items:[],
  tabs:{},
  allItem:'',
  checkedItem:'',
  topform:{
    activeStatus:1,
    pageNum: 1,
    pageSize: 10,
  },
  form: {
    pageNum: 1,
    pageSize: 4,
    activeStatus:0,
  },
});

 


const getData = () =>{
  getActive(datas.form).then((res: any) =>{
      for(const item of res.data.list){
        if(item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
      }
    datas.items = res.data.list;
  });
};

 
const getTop = () =>{
  getActive(datas.topform).then((res: any) =>{
      for(const item of res.data.list){
        if(item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
      }
      datas.tops = res.data.list;
      setTimeout(()=>{
        acrRef.value?.setActiveItem(0);
        },100);
  });
};

 
 const getTabs = () => {
  datas.tabs ={};
  getEnum("CUSTOMER").then((res: any) => {
    for (const item of res.data) {
       datas.tabs[item.enumKey] = item;
       datas.tabs[item.enumKey].checked = false;
    }
    datas.tabs['CUSTOMER_EDUCATION'].checked = true;
  });
};
 

const getCustom = () =>{
  getCustomer().then((res: any) =>{
      datas.allItem = res.data;
      datas.checkedItem =datas.allItem['CUSTOMER_EDUCATION'];
      for(const item of datas.checkedItem){
          if(item.fileName)  item.img = localStorage.getItem("fileUrel") + item.fileName;
      }
  });
}; 
 
const getBanner = (banner: any) => {
  datas.banner = banner;
};

const check = (k: any) =>{
    datas.show= false;
  for(const item in  datas.tabs) {
     datas.tabs[item].checked = false;
  }
  datas.tabs[k].checked = true;
  datas.checkedItem = datas.allItem[k];
  for(const item of datas.checkedItem){
      if(item.fileName)  item.img = localStorage.getItem("fileUrel") + item.fileName;
  }
  setTimeout(()=>{
       datas.show= true;
        },100);
 
};

const openUrl = (url: any) => {
    if (url) {
        window.open(url);
    }
};

onMounted(() => {
  getData();
  getTop();
  getTabs();
  getCustom();
  mb.value =props.isMobile;
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value?'Mobile':'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl+datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_carousel, {
          ref_key: "acrRef",
          ref: acrRef,
          height: mb.value?'8rem':'5.3rem',
          arrow: "never",
          "indicator-position": mb.value?'outside':''
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.tops, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                onClick: ($event: any) => (openUrl(item.linkUrl))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = _createElementVNode("small", null, "直播", -1)),
                    _createTextVNode(" " + _toDisplayString(item.activeName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item.fileurl,
                      alt: ""
                    }, null, 8, _hoisted_9),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "tag" }, "正在直播", -1))
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["height", "indicator-position"])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, "应用案例", -1)),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item", index==0?'big':'sm']),
            key: index
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_image, {
                src: item.fileurl,
                fit: "fill"
              }, {
                error: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "icon-tupian iconfont" }, null, -1)
                ]))]),
                _: 1
              }, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, _toDisplayString(item.activeName), 1),
              (index==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : _createCommentVNode("", true),
              (index==0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(item.description), 1))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "部分经典用户", -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.tabs, (v, k) => {
              return (_openBlock(), _createElementBlock("li", {
                key: k,
                class: _normalizeClass({checked:v.checked}),
                onClick: ($event: any) => (check(k))
              }, [
                _createTextVNode(_toDisplayString(v.enumName) + " ", 1),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                (v.checked)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_18))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (datas.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.checkedItem, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item",
                    key: index
                  }, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_22)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}
}

})